import React, { useContext } from "react";
import { Box, Heading, Text, SimpleGrid, Flex, Button, Badge } from "@chakra-ui/react";
import { HelmetComponent } from "../../components/HelmetComponent";
import { PublisherAndUserContext } from "../../contexts/PublisherAndUserContext";

export const IntegrationsPage = () => {
  const { user } = useContext(PublisherAndUserContext);

  return (
    <>
      <HelmetComponent title={`Integrations - Home - ${user?.firstName} ${user?.lastName}`} />
      <Box>
        <Flex align="center" mb={2}>
          <Heading as="h2" size="md">Integrations</Heading>
          <Badge colorScheme="purple" ml={3}>COMING SOON</Badge>
        </Flex>
        <Text color="gray.600" mb={6}>
          Connect your marketing tools. Manage analytics, pixels, and email integrations here.
        </Text>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          <Box p={4} borderWidth="1px" borderRadius="md">
            <Heading as="h3" size="sm" mb={1}>Google Analytics</Heading>
            <Text color="gray.600" mb={3}>Track traffic and user behavior across your store.</Text>
            <Flex>
              <Button size="sm" colorScheme="blue" isDisabled>Configure</Button>
              <Button size="sm" variant="ghost" ml={2} isDisabled>Docs</Button>
            </Flex>
          </Box>

          <Box p={4} borderWidth="1px" borderRadius="md">
            <Heading as="h3" size="sm" mb={1}>Facebook Pixel</Heading>
            <Text color="gray.600" mb={3}>Optimize ads and conversions with Pixel tracking.</Text>
            <Flex>
              <Button size="sm" colorScheme="blue" isDisabled>Configure</Button>
              <Button size="sm" variant="ghost" ml={2} isDisabled>Docs</Button>
            </Flex>
          </Box>

          <Box p={4} borderWidth="1px" borderRadius="md">
            <Heading as="h3" size="sm" mb={1}>Mailchimp</Heading>
            <Text color="gray.600" mb={3}>Sync customers and send targeted email campaigns.</Text>
            <Flex>
              <Button size="sm" colorScheme="blue" isDisabled>Configure</Button>
              <Button size="sm" variant="ghost" ml={2} isDisabled>Docs</Button>
            </Flex>
          </Box>

          <Box p={4} borderWidth="1px" borderRadius="md">
            <Heading as="h3" size="sm" mb={1}>Zapier</Heading>
            <Text color="gray.600" mb={3}>Automate workflows by connecting with thousands of apps.</Text>
            <Flex>
              <Button size="sm" colorScheme="blue" isDisabled>Configure</Button>
              <Button size="sm" variant="ghost" ml={2} isDisabled>Docs</Button>
            </Flex>
          </Box>
        </SimpleGrid>

        <Text color="gray.500" fontSize="sm" mt={6}>
          Integrations are coming soon. Let us know which you need first.
        </Text>
      </Box>
    </>
  );
};
